export const SDG_COLORS = [
    'bg-red-500', 'bg-yellow-500', 'bg-green-500', 'bg-red-600',
    'bg-orange-500', 'bg-blue-400', 'bg-yellow-400', 'bg-red-700',
    'bg-orange-600', 'bg-pink-500', 'bg-yellow-600', 'bg-yellow-700',
    'bg-green-600', 'bg-blue-500', 'bg-green-700', 'bg-blue-600',
    'bg-purple-600'
  ];
  
  export const SDG_TITLES = [
    'No Poverty', 'Zero Hunger', 'Good Health', 'Quality Education',
    'Gender Equality', 'Clean Water', 'Clean Energy', 'Economic Growth',
    'Innovation', 'Reduce Inequalities', 'Sustainable Cities', 'Responsible Consumption',
    'Climate Action', 'Life Below Water', 'Life on Land', 'Peace & Justice',
    'Partnerships'
  ];
  
  export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';